import { createSelector } from 'reselect';

const selectExternalAuthentications = (state: any) => state.externalAuthentications;


export const selectExternalAuthenticationsCurrentItem = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.current);

export const selectExternalAuthenticationsListItems = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.list);

export const selectExternalAuthenticationsItemById = (itemId: any) =>
    createSelector(selectExternalAuthenticationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectExternalAuthenticationsQueryItems = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.query);

export const selectExternalAuthenticationsCreatedItem = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.create);

export const selectExternalAuthenticationsUpdatedItem = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.update);

export const selectExternalAuthenticationsReadItem = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.read);

export const selectExternalAuthenticationsDeletedItem = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.delete);

export const selectExternalAuthenticationsearchedItems = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.search);

export const selectExternalAuthenticationsItemsCount = createSelector([selectExternalAuthentications], (externalAuthentications) => {console.log('ExternalAuthentication data', externalAuthentications); return externalAuthentications.count});

export const selectExternalAuthenticationsItemsFilter = createSelector([selectExternalAuthentications], (externalAuthentications) => externalAuthentications.filter);